import { jsonApi } from '../client';
import { generateResourceViewApi } from '../view/api';
import type { Tenant } from './types';

const tenant = jsonApi('tenant');

const current = (): Promise<Tenant> => {
  return tenant.get('current');
};

export const tenantApi = {
  name: 'tenant',
  current,
  view: generateResourceViewApi('tenant'),
};
